import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';

export default {
  async list({ query = {} } = {}) {
    const pickedQuery = _.pick(query, [
      'q',
      'page',
      'page_size',
      'filter',
      'search',
      'searchkey',
      'startdate',
      'enddate'
    ]);
    let url = `${configService.get('apiUrl')}/customer-transaction-complaint`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }
    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async deletedList({ type = 'archive', query = {} } = {}) {
    const pickedQuery = _.pick(query, [
      'q',
      'page',
      'page_size',
      'filter',
      'search',
      'searchkey',
      'startdate',
      'enddate',
      'type'
    ]);
    let url = `${configService.get('apiUrl')}/customer-transaction-complaint`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }
    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async getSignedUrl({ filetype }) {
    return axios
      .get(
        `${configService.get('apiUrl')}/customer-transaction-complaint-upload/get-signed-url?&filetype=${filetype}`,
        {}
      )
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async uploadImage({ url, file }) {
    const instance = axios.create();
    delete instance.defaults.headers.common.Authorization;
    const fileType = file.type;
    const config = {
      method: 'put',
      url,
      headers: {
        'Content-Type': fileType
      },
      data: file
    };
    return instance(config)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async getOne({ id }) {
    return axios
      .get(`${configService.get('apiUrl')}/customer-transaction-complaint/${id}`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async postOne({ complain }) {
    return axios
      .post(`${configService.get('apiUrl')}/customer-transaction-complaint`, complain)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async deleteOne({ id }) {
    return axios
      .delete(`${configService.get('apiUrl')}/customer-transaction-complaint/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async patchOne({ id, complain }) {
    return axios
      .patch(`${configService.get('apiUrl')}/customer-transaction-complaint/${id}`, complain)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async download({ query = {} } = {}) {
    const pickedQuery = _.pick(query, [
      'q',
      'page',
      'page_size',
      'filter',
      'search',
      'searchkey',
      'startdate',
      'enddate'
    ]);
    let url = `${configService.get('apiUrl')}/customer-transaction-complaint`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }
    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
